// Articles migrated from Magento end with a "¿Te fue útil este artículo? Sí / No" widget whose
// answers were never wired to anything. Turn them into buttons that thank the reader.
// Nothing is recorded.
document.querySelectorAll('[data-feedback-thanks]').forEach((content) => {
  content.querySelectorAll('.epa-btn').forEach((answer) => {
    answer.setAttribute('role', 'button');
    answer.setAttribute('tabindex', '0');
  });

  const thank = (event) => {
    const answer = event.target.closest('.epa-btn');
    if (!answer) return;
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();

    const message = document.createElement('p');
    message.className = 'epa-feedback-thanks';
    message.setAttribute('role', 'status');
    message.textContent = content.dataset.feedbackThanks;
    answer.parentElement.replaceChildren(message);
  };

  content.addEventListener('click', thank);
  content.addEventListener('keydown', thank);
});
